module.exports = __webpack_public_path__ + "static/media/2 (16).aa57176e.jpg";